export default __webpack_public_path__ + "static/media/alarm-history.5c63a0d9.svg";